"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useId = void 0;
var react_1 = require("react");
function useId(prefix) {
    var _id = (0, react_1.useId)();
    return prefix ? "".concat(prefix).concat(_id) : _id;
}
exports.useId = useId;
